import PageSectionTemplate from '@/templates/PageSection.template';
import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { useAcceptInvite } from './accept-invite.controller';

export default function AcceptInvitePage() {
	const { t, handleAcceptInviteClick, acceptInviteMutation } = useAcceptInvite();

	return (
		<PageSectionTemplate>
			<Box p={8} display="flex" flexDir="column">
				<Heading size="xl" fontWeight={800}>
					{t(`You've been invited to join a team!`)}
				</Heading>
				<Text my={4} color="gray.600">
					{t('If you accept the invitation. Other team members will be able to:')}
				</Text>

				<Heading size="md" mt={4}>
					{t('Manage your bookings.')}
				</Heading>
				<Text mt={2} color="gray.600" size="xs">
					{t('Any team member can see and edit your bookings.')}
				</Text>

				<Heading size="md" mt={4}>
					{t('Manage your booking pages.')}
				</Heading>
				<Text mt={2} color="gray.600" size="xs">
					{t('Any team member can see and edit your booking pages.')}
				</Text>
			</Box>

			<Button
				mt="auto"
				colorScheme="primary"
				w="full"
				onClick={handleAcceptInviteClick}
				isLoading={acceptInviteMutation.isLoading}
			>
				{t('Accept invite')}
			</Button>
		</PageSectionTemplate>
	);
}
